export default __webpack_public_path__ + "static/media/order.b44e772e.png";